interface IImportScriptProps {
  async?: boolean;
  id?: string;
  resourceUrl: string;
  onload?: () => void;
  preload?: () => Promise<boolean> | boolean;
}

const ImportScript = ({ async = false, id, resourceUrl, onload }: IImportScriptProps) => {
  const script = document.createElement('script');
  script.src = resourceUrl;
  script.async = async;
  if (id) script.id = id;
  if (onload) script.onload = onload;
  document.body.appendChild(script);
};

export default ImportScript;
